export default __webpack_public_path__ + "static/media/logo-us-freepeople.5afae89b.svg";